var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.198,
    height: 19.018,
    viewBox: "0 0 34.198 24.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8304",
    "data-name": "Group 8304",
    transform: "translate(15997.311 19313.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16071",
    "data-name": "Path 16071",
    d: "M890.893,14.514c4.1.227,8.375.4,12.64.727a4.14,4.14,0,0,1,3.948,3.7A42.731,42.731,0,0,1,908,28.9a52.471,52.471,0,0,1-.522,5.334,4.039,4.039,0,0,1-3.962,3.749c-4.892.283-9.793.514-14.691.544-3.406.021-6.82-.255-10.22-.536a4.23,4.23,0,0,1-4.181-4.022,50.062,50.062,0,0,1,.005-14.741,4.238,4.238,0,0,1,4.1-4.02c4.048-.329,8.111-.468,12.359-.7m-3.238,7.025v10.15l8.8-5.079-8.8-5.071",
    transform: "translate(-16871.195 -19328.006)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16072",
    "data-name": "Path 16072",
    d: "M910.163,33.023l8.8,5.071-8.8,5.079Z",
    transform: "translate(-16893.703 -19339.488)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6869770422cf7a541b3afa1edb89a1f3.svg";
export { ForwardRef as ReactComponent };